/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { automatedProcessCountProcessInstances } from '../fn/automated-process/automated-process-count-process-instances';
import { AutomatedProcessCountProcessInstances$Params } from '../fn/automated-process/automated-process-count-process-instances';
import { automatedProcessCreateTriggerEvent } from '../fn/automated-process/automated-process-create-trigger-event';
import { AutomatedProcessCreateTriggerEvent$Params } from '../fn/automated-process/automated-process-create-trigger-event';
import { automatedProcessCreateTriggerEventProcess } from '../fn/automated-process/automated-process-create-trigger-event-process';
import { AutomatedProcessCreateTriggerEventProcess$Params } from '../fn/automated-process/automated-process-create-trigger-event-process';
import { automatedProcessDeleteTriggerEvent } from '../fn/automated-process/automated-process-delete-trigger-event';
import { AutomatedProcessDeleteTriggerEvent$Params } from '../fn/automated-process/automated-process-delete-trigger-event';
import { automatedProcessDeleteTriggerEventProcess } from '../fn/automated-process/automated-process-delete-trigger-event-process';
import { AutomatedProcessDeleteTriggerEventProcess$Params } from '../fn/automated-process/automated-process-delete-trigger-event-process';
import { automatedProcessGetAllAutomatedProcessParameters } from '../fn/automated-process/automated-process-get-all-automated-process-parameters';
import { AutomatedProcessGetAllAutomatedProcessParameters$Params } from '../fn/automated-process/automated-process-get-all-automated-process-parameters';
import { automatedProcessGetAllDelegates } from '../fn/automated-process/automated-process-get-all-delegates';
import { AutomatedProcessGetAllDelegates$Params } from '../fn/automated-process/automated-process-get-all-delegates';
import { automatedProcessGetAllTriggerEventProcesses } from '../fn/automated-process/automated-process-get-all-trigger-event-processes';
import { AutomatedProcessGetAllTriggerEventProcesses$Params } from '../fn/automated-process/automated-process-get-all-trigger-event-processes';
import { automatedProcessGetAllTriggerEvents } from '../fn/automated-process/automated-process-get-all-trigger-events';
import { AutomatedProcessGetAllTriggerEvents$Params } from '../fn/automated-process/automated-process-get-all-trigger-events';
import { automatedProcessGetAllWorkflowTriggers } from '../fn/automated-process/automated-process-get-all-workflow-triggers';
import { AutomatedProcessGetAllWorkflowTriggers$Params } from '../fn/automated-process/automated-process-get-all-workflow-triggers';
import { automatedProcessGetProcessInstanceActivityLog } from '../fn/automated-process/automated-process-get-process-instance-activity-log';
import { AutomatedProcessGetProcessInstanceActivityLog$Params } from '../fn/automated-process/automated-process-get-process-instance-activity-log';
import { automatedProcessGetProcessInstanceDetails } from '../fn/automated-process/automated-process-get-process-instance-details';
import { AutomatedProcessGetProcessInstanceDetails$Params } from '../fn/automated-process/automated-process-get-process-instance-details';
import { automatedProcessGetProcessInstanceDiagram } from '../fn/automated-process/automated-process-get-process-instance-diagram';
import { AutomatedProcessGetProcessInstanceDiagram$Params } from '../fn/automated-process/automated-process-get-process-instance-diagram';
import { automatedProcessGetProcessInstanceHistory } from '../fn/automated-process/automated-process-get-process-instance-history';
import { AutomatedProcessGetProcessInstanceHistory$Params } from '../fn/automated-process/automated-process-get-process-instance-history';
import { automatedProcessGetTriggerEventById } from '../fn/automated-process/automated-process-get-trigger-event-by-id';
import { AutomatedProcessGetTriggerEventById$Params } from '../fn/automated-process/automated-process-get-trigger-event-by-id';
import { automatedProcessGetTriggerEventProcessById } from '../fn/automated-process/automated-process-get-trigger-event-process-by-id';
import { AutomatedProcessGetTriggerEventProcessById$Params } from '../fn/automated-process/automated-process-get-trigger-event-process-by-id';
import { AutomatedProcessParameterBaseDto } from '../models/automated-process-parameter-base-dto';
import { automatedProcessRetryActivity } from '../fn/automated-process/automated-process-retry-activity';
import { AutomatedProcessRetryActivity$Params } from '../fn/automated-process/automated-process-retry-activity';
import { automatedProcessSearchProcessInstances } from '../fn/automated-process/automated-process-search-process-instances';
import { AutomatedProcessSearchProcessInstances$Params } from '../fn/automated-process/automated-process-search-process-instances';
import { automatedProcessSearchTriggerEventProcesses } from '../fn/automated-process/automated-process-search-trigger-event-processes';
import { AutomatedProcessSearchTriggerEventProcesses$Params } from '../fn/automated-process/automated-process-search-trigger-event-processes';
import { automatedProcessSearchTriggerEvents } from '../fn/automated-process/automated-process-search-trigger-events';
import { AutomatedProcessSearchTriggerEvents$Params } from '../fn/automated-process/automated-process-search-trigger-events';
import { automatedProcessSkipActivity } from '../fn/automated-process/automated-process-skip-activity';
import { AutomatedProcessSkipActivity$Params } from '../fn/automated-process/automated-process-skip-activity';
import { automatedProcessTerminate } from '../fn/automated-process/automated-process-terminate';
import { AutomatedProcessTerminate$Params } from '../fn/automated-process/automated-process-terminate';
import { automatedProcessUpdateTriggerEvent } from '../fn/automated-process/automated-process-update-trigger-event';
import { AutomatedProcessUpdateTriggerEvent$Params } from '../fn/automated-process/automated-process-update-trigger-event';
import { automatedProcessUpdateTriggerEventProcess } from '../fn/automated-process/automated-process-update-trigger-event-process';
import { AutomatedProcessUpdateTriggerEventProcess$Params } from '../fn/automated-process/automated-process-update-trigger-event-process';
import { automatedProcessValidateTriggerEventProcess } from '../fn/automated-process/automated-process-validate-trigger-event-process';
import { AutomatedProcessValidateTriggerEventProcess$Params } from '../fn/automated-process/automated-process-validate-trigger-event-process';
import { DelegateDto } from '../models/delegate-dto';
import { PageProcessInstanceDto } from '../models/page-process-instance-dto';
import { PageWorkflowTriggerEventDto } from '../models/page-workflow-trigger-event-dto';
import { PageWorkflowTriggerEventProcessDto } from '../models/page-workflow-trigger-event-process-dto';
import { ProcessInstanceActivityLogDto } from '../models/process-instance-activity-log-dto';
import { ProcessInstanceDto } from '../models/process-instance-dto';
import { ProcessInstanceHistoryDto } from '../models/process-instance-history-dto';
import { WorkflowTriggerDto } from '../models/workflow-trigger-dto';
import { WorkflowTriggerEventDto } from '../models/workflow-trigger-event-dto';
import { WorkflowTriggerEventProcessCompleteDto } from '../models/workflow-trigger-event-process-complete-dto';
import { WorkflowTriggerEventProcessDto } from '../models/workflow-trigger-event-process-dto';
import { WorkflowTriggerEventProcessValidationResultDto } from '../models/workflow-trigger-event-process-validation-result-dto';


/**
 * Contains endpoints related to automated processes
 */
@Injectable({ providedIn: 'root' })
export class ApiAutomatedProcessService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `automatedProcessGetTriggerEventById()` */
  static readonly AutomatedProcessGetTriggerEventByIdPath = '/automated-process/workflow-trigger/trigger-event/{id}';

  /**
   * Get trigger event by ID.
   *
   * Retrieves a specific workflow trigger event by its ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessGetTriggerEventById()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetTriggerEventById$Response(params: AutomatedProcessGetTriggerEventById$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventDto>> {
    const obs = automatedProcessGetTriggerEventById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get trigger event by ID.
   *
   * Retrieves a specific workflow trigger event by its ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessGetTriggerEventById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetTriggerEventById(params: AutomatedProcessGetTriggerEventById$Params, context?: HttpContext): Observable<WorkflowTriggerEventDto> {
    const resp = this.automatedProcessGetTriggerEventById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<WorkflowTriggerEventDto>): WorkflowTriggerEventDto => r.body)
    );
  }

  /** Path part for operation `automatedProcessUpdateTriggerEvent()` */
  static readonly AutomatedProcessUpdateTriggerEventPath = '/automated-process/workflow-trigger/trigger-event/{id}';

  /**
   * Update trigger event.
   *
   * Updates an existing workflow trigger event.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessUpdateTriggerEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessUpdateTriggerEvent$Response(params: AutomatedProcessUpdateTriggerEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventDto>> {
    const obs = automatedProcessUpdateTriggerEvent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update trigger event.
   *
   * Updates an existing workflow trigger event.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessUpdateTriggerEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessUpdateTriggerEvent(params: AutomatedProcessUpdateTriggerEvent$Params, context?: HttpContext): Observable<WorkflowTriggerEventDto> {
    const resp = this.automatedProcessUpdateTriggerEvent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<WorkflowTriggerEventDto>): WorkflowTriggerEventDto => r.body)
    );
  }

  /** Path part for operation `automatedProcessDeleteTriggerEvent()` */
  static readonly AutomatedProcessDeleteTriggerEventPath = '/automated-process/workflow-trigger/trigger-event/{id}';

  /**
   * Delete trigger event.
   *
   * Deletes a workflow trigger event by its ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessDeleteTriggerEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessDeleteTriggerEvent$Response(params: AutomatedProcessDeleteTriggerEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = automatedProcessDeleteTriggerEvent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete trigger event.
   *
   * Deletes a workflow trigger event by its ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessDeleteTriggerEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessDeleteTriggerEvent(params: AutomatedProcessDeleteTriggerEvent$Params, context?: HttpContext): Observable<void> {
    const resp = this.automatedProcessDeleteTriggerEvent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `automatedProcessGetTriggerEventProcessById()` */
  static readonly AutomatedProcessGetTriggerEventProcessByIdPath = '/automated-process/workflow-trigger/trigger-event-process/{id}';

  /**
   * Get trigger event process by ID.
   *
   * Retrieves a specific workflow trigger event process by its ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessGetTriggerEventProcessById()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetTriggerEventProcessById$Response(params: AutomatedProcessGetTriggerEventProcessById$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventProcessCompleteDto>> {
    const obs = automatedProcessGetTriggerEventProcessById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get trigger event process by ID.
   *
   * Retrieves a specific workflow trigger event process by its ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessGetTriggerEventProcessById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetTriggerEventProcessById(params: AutomatedProcessGetTriggerEventProcessById$Params, context?: HttpContext): Observable<WorkflowTriggerEventProcessCompleteDto> {
    const resp = this.automatedProcessGetTriggerEventProcessById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<WorkflowTriggerEventProcessCompleteDto>): WorkflowTriggerEventProcessCompleteDto => r.body)
    );
  }

  /** Path part for operation `automatedProcessUpdateTriggerEventProcess()` */
  static readonly AutomatedProcessUpdateTriggerEventProcessPath = '/automated-process/workflow-trigger/trigger-event-process/{id}';

  /**
   * Update trigger event process.
   *
   * Updates an existing workflow trigger event process.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessUpdateTriggerEventProcess()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessUpdateTriggerEventProcess$Response(params: AutomatedProcessUpdateTriggerEventProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventProcessDto>> {
    const obs = automatedProcessUpdateTriggerEventProcess(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update trigger event process.
   *
   * Updates an existing workflow trigger event process.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessUpdateTriggerEventProcess$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessUpdateTriggerEventProcess(params: AutomatedProcessUpdateTriggerEventProcess$Params, context?: HttpContext): Observable<WorkflowTriggerEventProcessDto> {
    const resp = this.automatedProcessUpdateTriggerEventProcess$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<WorkflowTriggerEventProcessDto>): WorkflowTriggerEventProcessDto => r.body)
    );
  }

  /** Path part for operation `automatedProcessDeleteTriggerEventProcess()` */
  static readonly AutomatedProcessDeleteTriggerEventProcessPath = '/automated-process/workflow-trigger/trigger-event-process/{id}';

  /**
   * Delete trigger event process.
   *
   * Deletes a workflow trigger event process by its ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessDeleteTriggerEventProcess()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessDeleteTriggerEventProcess$Response(params: AutomatedProcessDeleteTriggerEventProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = automatedProcessDeleteTriggerEventProcess(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete trigger event process.
   *
   * Deletes a workflow trigger event process by its ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessDeleteTriggerEventProcess$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessDeleteTriggerEventProcess(params: AutomatedProcessDeleteTriggerEventProcess$Params, context?: HttpContext): Observable<void> {
    const resp = this.automatedProcessDeleteTriggerEventProcess$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `automatedProcessGetAllTriggerEvents()` */
  static readonly AutomatedProcessGetAllTriggerEventsPath = '/automated-process/workflow-trigger/trigger-event';

  /**
   * Get all trigger events.
   *
   * Retrieves a list of all workflow trigger events.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessGetAllTriggerEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetAllTriggerEvents$Response(params?: AutomatedProcessGetAllTriggerEvents$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowTriggerEventDto>>> {
    const obs = automatedProcessGetAllTriggerEvents(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all trigger events.
   *
   * Retrieves a list of all workflow trigger events.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessGetAllTriggerEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetAllTriggerEvents(params?: AutomatedProcessGetAllTriggerEvents$Params|null|undefined, context?: HttpContext): Observable<Array<WorkflowTriggerEventDto>> {
    const resp = this.automatedProcessGetAllTriggerEvents$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WorkflowTriggerEventDto>>): Array<WorkflowTriggerEventDto> => r.body)
    );
  }

  /** Path part for operation `automatedProcessCreateTriggerEvent()` */
  static readonly AutomatedProcessCreateTriggerEventPath = '/automated-process/workflow-trigger/trigger-event';

  /**
   * Create trigger event.
   *
   * Creates a new workflow trigger event.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessCreateTriggerEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessCreateTriggerEvent$Response(params: AutomatedProcessCreateTriggerEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventDto>> {
    const obs = automatedProcessCreateTriggerEvent(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create trigger event.
   *
   * Creates a new workflow trigger event.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessCreateTriggerEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessCreateTriggerEvent(params: AutomatedProcessCreateTriggerEvent$Params, context?: HttpContext): Observable<WorkflowTriggerEventDto> {
    const resp = this.automatedProcessCreateTriggerEvent$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<WorkflowTriggerEventDto>): WorkflowTriggerEventDto => r.body)
    );
  }

  /** Path part for operation `automatedProcessSearchTriggerEvents()` */
  static readonly AutomatedProcessSearchTriggerEventsPath = '/automated-process/workflow-trigger/trigger-event/search-api';

  /**
   * Search trigger events.
   *
   * Searches for workflow trigger events based on criteria.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessSearchTriggerEvents()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessSearchTriggerEvents$Response(params?: AutomatedProcessSearchTriggerEvents$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<PageWorkflowTriggerEventDto>> {
    const obs = automatedProcessSearchTriggerEvents(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search trigger events.
   *
   * Searches for workflow trigger events based on criteria.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessSearchTriggerEvents$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessSearchTriggerEvents(params?: AutomatedProcessSearchTriggerEvents$Params|null|undefined, context?: HttpContext): Observable<PageWorkflowTriggerEventDto> {
    const resp = this.automatedProcessSearchTriggerEvents$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageWorkflowTriggerEventDto>): PageWorkflowTriggerEventDto => r.body)
    );
  }

  /** Path part for operation `automatedProcessGetAllTriggerEventProcesses()` */
  static readonly AutomatedProcessGetAllTriggerEventProcessesPath = '/automated-process/workflow-trigger/trigger-event-process';

  /**
   * Get all trigger event processes.
   *
   * Retrieves a list of all workflow trigger event processes.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessGetAllTriggerEventProcesses()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetAllTriggerEventProcesses$Response(params?: AutomatedProcessGetAllTriggerEventProcesses$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowTriggerEventProcessDto>>> {
    const obs = automatedProcessGetAllTriggerEventProcesses(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all trigger event processes.
   *
   * Retrieves a list of all workflow trigger event processes.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessGetAllTriggerEventProcesses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetAllTriggerEventProcesses(params?: AutomatedProcessGetAllTriggerEventProcesses$Params|null|undefined, context?: HttpContext): Observable<Array<WorkflowTriggerEventProcessDto>> {
    const resp = this.automatedProcessGetAllTriggerEventProcesses$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WorkflowTriggerEventProcessDto>>): Array<WorkflowTriggerEventProcessDto> => r.body)
    );
  }

  /** Path part for operation `automatedProcessCreateTriggerEventProcess()` */
  static readonly AutomatedProcessCreateTriggerEventProcessPath = '/automated-process/workflow-trigger/trigger-event-process';

  /**
   * Create trigger event process.
   *
   * Creates a new workflow trigger event process.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessCreateTriggerEventProcess()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessCreateTriggerEventProcess$Response(params: AutomatedProcessCreateTriggerEventProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventProcessDto>> {
    const obs = automatedProcessCreateTriggerEventProcess(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create trigger event process.
   *
   * Creates a new workflow trigger event process.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessCreateTriggerEventProcess$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessCreateTriggerEventProcess(params: AutomatedProcessCreateTriggerEventProcess$Params, context?: HttpContext): Observable<WorkflowTriggerEventProcessDto> {
    const resp = this.automatedProcessCreateTriggerEventProcess$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<WorkflowTriggerEventProcessDto>): WorkflowTriggerEventProcessDto => r.body)
    );
  }

  /** Path part for operation `automatedProcessValidateTriggerEventProcess()` */
  static readonly AutomatedProcessValidateTriggerEventProcessPath = '/automated-process/workflow-trigger/trigger-event-process/validate';

  /**
   * Validate trigger event process.
   *
   * Validates a BPMN process definition.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessValidateTriggerEventProcess()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessValidateTriggerEventProcess$Response(params: AutomatedProcessValidateTriggerEventProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowTriggerEventProcessValidationResultDto>> {
    const obs = automatedProcessValidateTriggerEventProcess(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Validate trigger event process.
   *
   * Validates a BPMN process definition.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessValidateTriggerEventProcess$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessValidateTriggerEventProcess(params: AutomatedProcessValidateTriggerEventProcess$Params, context?: HttpContext): Observable<WorkflowTriggerEventProcessValidationResultDto> {
    const resp = this.automatedProcessValidateTriggerEventProcess$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<WorkflowTriggerEventProcessValidationResultDto>): WorkflowTriggerEventProcessValidationResultDto => r.body)
    );
  }

  /** Path part for operation `automatedProcessSearchTriggerEventProcesses()` */
  static readonly AutomatedProcessSearchTriggerEventProcessesPath = '/automated-process/workflow-trigger/trigger-event-process/search-api';

  /**
   * Search trigger event processes.
   *
   * Searches for workflow trigger event processes based on criteria.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessSearchTriggerEventProcesses()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessSearchTriggerEventProcesses$Response(params?: AutomatedProcessSearchTriggerEventProcesses$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<PageWorkflowTriggerEventProcessDto>> {
    const obs = automatedProcessSearchTriggerEventProcesses(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search trigger event processes.
   *
   * Searches for workflow trigger event processes based on criteria.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessSearchTriggerEventProcesses$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessSearchTriggerEventProcesses(params?: AutomatedProcessSearchTriggerEventProcesses$Params|null|undefined, context?: HttpContext): Observable<PageWorkflowTriggerEventProcessDto> {
    const resp = this.automatedProcessSearchTriggerEventProcesses$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageWorkflowTriggerEventProcessDto>): PageWorkflowTriggerEventProcessDto => r.body)
    );
  }

  /** Path part for operation `automatedProcessSearchProcessInstances()` */
  static readonly AutomatedProcessSearchProcessInstancesPath = '/automated-process/process-instance/{workflowTriggerEventProcessId}/search-api';

  /**
   * Search process instances by workflow trigger event process ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessSearchProcessInstances()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessSearchProcessInstances$Response(params: AutomatedProcessSearchProcessInstances$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProcessInstanceDto>> {
    const obs = automatedProcessSearchProcessInstances(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search process instances by workflow trigger event process ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessSearchProcessInstances$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  automatedProcessSearchProcessInstances(params: AutomatedProcessSearchProcessInstances$Params, context?: HttpContext): Observable<PageProcessInstanceDto> {
    const resp = this.automatedProcessSearchProcessInstances$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageProcessInstanceDto>): PageProcessInstanceDto => r.body)
    );
  }

  /** Path part for operation `automatedProcessSkipActivity()` */
  static readonly AutomatedProcessSkipActivityPath = '/automated-process/process-instance/{processInstanceId}/activity/{activityId}/skip';

  /**
   * Skip activity.
   *
   * Cancels the specified activity and moves execution to next steps.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessSkipActivity()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessSkipActivity$Response(params: AutomatedProcessSkipActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = automatedProcessSkipActivity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Skip activity.
   *
   * Cancels the specified activity and moves execution to next steps.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessSkipActivity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessSkipActivity(params: AutomatedProcessSkipActivity$Params, context?: HttpContext): Observable<void> {
    const resp = this.automatedProcessSkipActivity$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `automatedProcessRetryActivity()` */
  static readonly AutomatedProcessRetryActivityPath = '/automated-process/process-instance/{processInstanceId}/activity/{activityId}/retry';

  /**
   * Retry activity.
   *
   * Retries a specific failed activity instance.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessRetryActivity()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessRetryActivity$Response(params: AutomatedProcessRetryActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = automatedProcessRetryActivity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retry activity.
   *
   * Retries a specific failed activity instance.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessRetryActivity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessRetryActivity(params: AutomatedProcessRetryActivity$Params, context?: HttpContext): Observable<void> {
    const resp = this.automatedProcessRetryActivity$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `automatedProcessGetAllWorkflowTriggers()` */
  static readonly AutomatedProcessGetAllWorkflowTriggersPath = '/automated-process/workflow-trigger';

  /**
   * Get all workflow triggers.
   *
   * Retrieves a list of all available workflow triggers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessGetAllWorkflowTriggers()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetAllWorkflowTriggers$Response(params?: AutomatedProcessGetAllWorkflowTriggers$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowTriggerDto>>> {
    const obs = automatedProcessGetAllWorkflowTriggers(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all workflow triggers.
   *
   * Retrieves a list of all available workflow triggers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessGetAllWorkflowTriggers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetAllWorkflowTriggers(params?: AutomatedProcessGetAllWorkflowTriggers$Params|null|undefined, context?: HttpContext): Observable<Array<WorkflowTriggerDto>> {
    const resp = this.automatedProcessGetAllWorkflowTriggers$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<WorkflowTriggerDto>>): Array<WorkflowTriggerDto> => r.body)
    );
  }

  /** Path part for operation `automatedProcessCountProcessInstances()` */
  static readonly AutomatedProcessCountProcessInstancesPath = '/automated-process/process-instance/{workflowTriggerEventProcessId}/count';

  /**
   * Count process instances by workflow trigger event process ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessCountProcessInstances()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessCountProcessInstances$Response(params: AutomatedProcessCountProcessInstances$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    const obs = automatedProcessCountProcessInstances(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Count process instances by workflow trigger event process ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessCountProcessInstances$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessCountProcessInstances(params: AutomatedProcessCountProcessInstances$Params, context?: HttpContext): Observable<number> {
    const resp = this.automatedProcessCountProcessInstances$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `automatedProcessGetProcessInstanceDetails()` */
  static readonly AutomatedProcessGetProcessInstanceDetailsPath = '/automated-process/process-instance/{processInstanceId}';

  /**
   * Get process details.
   *
   * Retrieves state, variables, and timing info for a process (active or historic).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessGetProcessInstanceDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetProcessInstanceDetails$Response(params: AutomatedProcessGetProcessInstanceDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessInstanceDto>> {
    const obs = automatedProcessGetProcessInstanceDetails(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get process details.
   *
   * Retrieves state, variables, and timing info for a process (active or historic).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessGetProcessInstanceDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetProcessInstanceDetails(params: AutomatedProcessGetProcessInstanceDetails$Params, context?: HttpContext): Observable<ProcessInstanceDto> {
    const resp = this.automatedProcessGetProcessInstanceDetails$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProcessInstanceDto>): ProcessInstanceDto => r.body)
    );
  }

  /** Path part for operation `automatedProcessGetProcessInstanceHistory()` */
  static readonly AutomatedProcessGetProcessInstanceHistoryPath = '/automated-process/process-instance/{processInstanceId}/history';

  /**
   * Get process history.
   *
   * Retrieves historical audit trail (steps executed) for a specific process instance.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessGetProcessInstanceHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetProcessInstanceHistory$Response(params: AutomatedProcessGetProcessInstanceHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProcessInstanceHistoryDto>>> {
    const obs = automatedProcessGetProcessInstanceHistory(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get process history.
   *
   * Retrieves historical audit trail (steps executed) for a specific process instance.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessGetProcessInstanceHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetProcessInstanceHistory(params: AutomatedProcessGetProcessInstanceHistory$Params, context?: HttpContext): Observable<Array<ProcessInstanceHistoryDto>> {
    const resp = this.automatedProcessGetProcessInstanceHistory$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ProcessInstanceHistoryDto>>): Array<ProcessInstanceHistoryDto> => r.body)
    );
  }

  /** Path part for operation `automatedProcessGetProcessInstanceDiagram()` */
  static readonly AutomatedProcessGetProcessInstanceDiagramPath = '/automated-process/process-instance/{processInstanceId}/diagram';

  /**
   * Get process diagram.
   *
   * Generates a PNG image of the process with the current path highlighted.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessGetProcessInstanceDiagram()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetProcessInstanceDiagram$Response(params: AutomatedProcessGetProcessInstanceDiagram$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = automatedProcessGetProcessInstanceDiagram(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get process diagram.
   *
   * Generates a PNG image of the process with the current path highlighted.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessGetProcessInstanceDiagram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetProcessInstanceDiagram(params: AutomatedProcessGetProcessInstanceDiagram$Params, context?: HttpContext): Observable<string> {
    const resp = this.automatedProcessGetProcessInstanceDiagram$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `automatedProcessGetProcessInstanceActivityLog()` */
  static readonly AutomatedProcessGetProcessInstanceActivityLogPath = '/automated-process/process-instance/{processInstanceId}/activity-log';

  /**
   * Get activity log.
   *
   * Retrieves the audit trail (steps executed) for a specific process instance.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessGetProcessInstanceActivityLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetProcessInstanceActivityLog$Response(params: AutomatedProcessGetProcessInstanceActivityLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProcessInstanceActivityLogDto>>> {
    const obs = automatedProcessGetProcessInstanceActivityLog(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get activity log.
   *
   * Retrieves the audit trail (steps executed) for a specific process instance.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessGetProcessInstanceActivityLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetProcessInstanceActivityLog(params: AutomatedProcessGetProcessInstanceActivityLog$Params, context?: HttpContext): Observable<Array<ProcessInstanceActivityLogDto>> {
    const resp = this.automatedProcessGetProcessInstanceActivityLog$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ProcessInstanceActivityLogDto>>): Array<ProcessInstanceActivityLogDto> => r.body)
    );
  }

  /** Path part for operation `automatedProcessGetAllAutomatedProcessParameters()` */
  static readonly AutomatedProcessGetAllAutomatedProcessParametersPath = '/automated-process/parameter';

  /**
   * Get all automated process parameters.
   *
   * Retrieves a list of all available automated process parameters.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessGetAllAutomatedProcessParameters()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetAllAutomatedProcessParameters$Response(params?: AutomatedProcessGetAllAutomatedProcessParameters$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<Array<AutomatedProcessParameterBaseDto>>> {
    const obs = automatedProcessGetAllAutomatedProcessParameters(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all automated process parameters.
   *
   * Retrieves a list of all available automated process parameters.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessGetAllAutomatedProcessParameters$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetAllAutomatedProcessParameters(params?: AutomatedProcessGetAllAutomatedProcessParameters$Params|null|undefined, context?: HttpContext): Observable<Array<AutomatedProcessParameterBaseDto>> {
    const resp = this.automatedProcessGetAllAutomatedProcessParameters$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<AutomatedProcessParameterBaseDto>>): Array<AutomatedProcessParameterBaseDto> => r.body)
    );
  }

  /** Path part for operation `automatedProcessGetAllDelegates()` */
  static readonly AutomatedProcessGetAllDelegatesPath = '/automated-process/delegate';

  /**
   * Get all delegates.
   *
   * Retrieves a list of all available delegates.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessGetAllDelegates()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetAllDelegates$Response(params?: AutomatedProcessGetAllDelegates$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<Array<DelegateDto>>> {
    const obs = automatedProcessGetAllDelegates(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all delegates.
   *
   * Retrieves a list of all available delegates.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessGetAllDelegates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessGetAllDelegates(params?: AutomatedProcessGetAllDelegates$Params|null|undefined, context?: HttpContext): Observable<Array<DelegateDto>> {
    const resp = this.automatedProcessGetAllDelegates$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DelegateDto>>): Array<DelegateDto> => r.body)
    );
  }

  /** Path part for operation `automatedProcessTerminate()` */
  static readonly AutomatedProcessTerminatePath = '/automated-process/process-instance/{processInstanceId}/terminate';

  /**
   * Terminate process.
   *
   * Stops and deletes the runtime instance.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `automatedProcessTerminate()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessTerminate$Response(params: AutomatedProcessTerminate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = automatedProcessTerminate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Terminate process.
   *
   * Stops and deletes the runtime instance.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `automatedProcessTerminate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  automatedProcessTerminate(params: AutomatedProcessTerminate$Params, context?: HttpContext): Observable<void> {
    const resp = this.automatedProcessTerminate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
